module.exports = __webpack_public_path__ + "img/getmuddybw.bb4d136c.png";